<template>
  <form-field-select
    :label="label"
    v-model="filterValue"
    placeholder="no filter"
    @change="handleInput"
    :help-text="helpText"
  >
    <option
      v-for="options in options"
      :value="options.id"
      :key="options.id"
    >{{ options.label }}
    </option>
  </form-field-select>
</template>

<script>
export default {
  name: "FilterSequencesStatuses",
  props: {
    label: {
      type: String,
      default: "Sequence Statuses"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
    helpText: String,
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].sequenceStatus;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "sequenceStatus",
          value
        ]);
      }
    },
    options() {
      return [
        {id: null, label: "no filter"},
        {id: 3, label: "Leads with Paused Sequences"},
        {id: 1, label: "Leads with Active Sequences"}
      ];
    },
    text() {
      if (this.filterValue) {
        if (this.filterValue === 3) return "Leads with Paused Sequences";
        if (this.filterValue === 1) return "Leads with Active Sequences";
        return null;
      }
      return null;
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
